var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "iOSLanding" } }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "intro" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Let's get the Muster app installed on your iOS device from the Apple App Store."
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "button",
        {
          on: {
            click: function($event) {
              return _vm.getApp()
            }
          }
        },
        [_vm._v("Get Muster")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "splashLogoContainer" }, [
      _c("img", {
        staticClass: "splashLogoTop",
        attrs: { src: require("../assets/images/SplashLogoTop.png") }
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "splashLogoBottom",
        attrs: { src: require("../assets/images/SplashLogoBottom.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("Welcome to "),
      _c("a", { attrs: { href: "https://muster.io/", target: "_blank" } }, [
        _vm._v("Muster")
      ]),
      _vm._v(", the most efficient way to get together.")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ef09e5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ef09e5a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/iOSLanding.vue
// module id = null
// module chunks = 